// extracted by mini-css-extract-plugin
export default {"formSection":"form-section_formSection__L6+Os","title":"form-section_title__T02Vg","content":"form-section_content__+Jlqt"};